import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';
import { WebAccessControlSchedulerFormBaseDataProvider } from '../dataProvider/WebAccessControlSchedulerFormBaseDataProvider';

export class WebAccessControlSchedulerFormFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, WebAccessControlSchedulerFormBaseDataProvider);
  }
}
